<!-- Free Form Style Form -->
@if (freeFormStyleForm) {
  <medsurf-design-form-control-form
    [formGroup]="freeFormStyleForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.shape">
      </h4>
      <!-- Height -->
      <medsurf-design-form-control-input-number [control]="freeFormStyleForm.controls.height"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.height'"
        [showButtons]="false"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      <!-- Width -->
      <medsurf-design-form-control-input-number [control]="freeFormStyleForm.controls.width"
        [class]="'w-full'"
        [min]="0"
        [label]="'global.width'"
        [showButtons]="false"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      <!-- Angle -->
      <medsurf-design-form-control-input-slider [control]="freeFormStyleForm.controls.angle"
        [class]="'w-full'"
        [min]="0"
        [max]="360"
        [label]="'global.angle'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}